// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__kBqxI","tab":"style_tab__UaW8s","tabActive":"style_tabActive__1G4qZ"};